/* global wp */
import wpLogo from '../../images/sync/wordpress.png'
import wpLogo2x from '../../images/sync/wordpress@2x.png'
import wpTitledLogo from '../../images/sync/wordpress-tilted.png'
import wpTitledLogo2x from '../../images/sync/wordpress-tilted@2x.png'

const { __ } = wp.i18n

const WpLogoImage = ({ start }) => {
	return (
		<img
			src={start ? wpLogo : wpTitledLogo}
			srcSet={`${start ? wpLogo : wpTitledLogo} 1x, ${start ? wpLogo2x : wpTitledLogo2x} 2x`}
			className="sui-image"
			alt={__('Connecting...', 'wpmudev')}
		/>
	)
}

export default WpLogoImage
